import {
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { IObjectKeys } from "../../../../../../utils/formTypes";

export enum ItmsChallansOrderField {
  CREATED_AT = "CREATED_AT",
  DATE = "DATE",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ItmsChallansOrder {
  direction: OrderDirection;
  field: ItmsChallansOrderField;
}

export interface GetItmsChallansVars {
  token?: String;
  customer_id: number;
  after: string | null;
  first: number;
  orderBy: ItmsChallansOrder;
  name: string;
  startDate?: string;
  endDate?: string;
  challanTypeIn: ItmsChallanType[];
}

export interface ItmsChallans {
  id: number;
  date: string;
  stopLine: number;
  seatBelt: number;
  jumpingSignal: number;
  tripleRide: number;
  noHelmet: number;
  overSpeed: number;
  driverOnCall: number;
  total: number;
  customerID: number;
  challanType: ItmsChallanType;
}

export interface ItmsChallansEdge {
  node: ItmsChallans;
  cursor: string;
}

export interface ItmsChallansConnection {
  edges: ItmsChallansEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetItmsChallansResult {
  GetItmsChallans: ItmsChallansConnection;
}

export interface CreateItmsChallansFormType extends IObjectKeys {
  date: string;
  stopLine: number;
  seatBelt: number;
  jumpingSignal: number;
  tripleRide: number;
  noHelmet: number;
  overSpeed: number;
  driverOnCall: number;
}

export enum ItmsChallanType {
  BIAL = "BIAL",
  ITMS = "ITMS",
}
export interface CreateItmsChallanInput {
  date: string;
  stopLine: number;
  seatBelt: number;
  jumpingSignal: number;
  tripleRide: number;
  noHelmet: number;
  overSpeed: number;
  driverOnCall: number;
  challanType: ItmsChallanType;
}

export interface AddItmsChallanVars {
  token?: string;
  customer_id: number;
  user_details: userDetails;
  input: CreateItmsChallanInput;
}

export interface AddItmsChallanResult {
  AddItmsChallan: boolean;
}

export interface UpdateItmsChallanResult {
  UpdateItmsChallan: boolean;
}

export interface UpdateItmsChallanInput {
  date: string;
  stopLine: number;
  seatBelt: number;
  jumpingSignal: number;
  tripleRide: number;
  noHelmet: number;
  overSpeed: number;
  driverOnCall: number;
  challanType: ItmsChallanType;
}

export interface UpdateItmsChallanVar {
  token?: string;
  itms_challan_id: number;
  user_details: userDetails;
  input: UpdateItmsChallanInput;
}

export interface ItmsChallansTotalCountConnection {
  stopLine: number;
  seatBelt: number;
  jumpingSignal: number;
  tripleRide: number;
  noHelmet: number;
  overSpeed: number;
  driverOnCall: number;
  total: number;
}

export interface GetItmsChallansTotalCountResult {
  GetItmsChallansTotalCount: ItmsChallansTotalCountConnection;
}

export interface GetItmsChallansTotalCountVar {
  token?: string;
  customer_id: number;
  startDate: string;
  endDate: string;
}

export interface ExportItmsChallansResult {
  ExportItmsChallans: string;
}

export interface ExportItmsChallansVariables {
  token?: string;
  customer_id: number;
  startDate?: string;
  endDate?: string;
  challanType?: ItmsChallanType;
}

export interface ExportItmsChallansTemplateVars {
  token?: string;
  customerID: number;
}

export interface ExportItmsChallansTemplateResult {
  ExportItmsChallansTemplate: string;
}

export interface ImportItmsChallansData {
  date: string;
  stopLine?: number;
  seatBelt?: number;
  jumpingSignal?: number;
  tripleRide?: number;
  noHelmet?: number;
  overSpeed?: number;
  driverOnCall?: number;
  challanType: ItmsChallanType;
}

export interface ValidateItmsChallansForImportVar {
  token?: string;
  customerID: number;
  input: ImportItmsChallansData;
}

export interface ValidateItmsChallansForImportResult{
  ValidateItmsChallansForImport : boolean
}

export interface ImportItmsChallanInput{
  date: string
stopLine: number
seatBelt: number
jumpingSignal: number
tripleRide: number
noHelmet: number
overSpeed: number
driverOnCall: number
challanType: ItmsChallanType
}

export interface ImportItmsChallanVars{
  token?: string
customer_id: number
user_details: userDetails
input: ImportItmsChallanInput
}

export interface ImportItmsChallanResult{
  ImportItmsChallan: boolean
}